import React from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import { Modal } from 'hyperdb-utils';
import SearchForm from '../../../daily-rental/availabilities/components/SearchForm';

class ItemActions extends React.Component {
  constructor(props) {
    super(props);
    this.handleCancelAction = this.handleCancelAction.bind(this);
    this.handleConfirmAction = this.handleConfirmAction.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.state = {
      selectedAction: null,
      sendOffer: null,
    };
  }
  render() {
    const title = this.props.title ? this.props.title : <span><i className="fas fa-caret" /> Actions</span>;
    const iconClass = this.props.icon ? `fas fa-${this.props.icon}` : '';
    const canMarkRead = this.props.forBatch ? this.props.filter !== 'processed' : !this.props.message.read;
    const canMarkProcessed = this.props.forBatch ? this.props.filter !== 'processed' : (this.props.message.pending || !this.props.message.read);
    const dropdownProps = { title, bsSize: 'small', id: 'Menu actions', className: iconClass, disabled: this.props.disabled };
    if (this.props.forBatch) {
      dropdownProps.pullLeft = true;
    } else {
      dropdownProps.pullRight = true;
    }
    return (
      <div>
        <DropdownButton { ...dropdownProps} >
          {
            this.props.folder === 'draft' && !this.props.forBatch
              ? <MenuItem onClick={ this.handleEdit.bind(this, this.props.message) }>Edit</MenuItem>
              : null
          }
          <MenuItem onClick={ this.handleDelete.bind(this) }>Delete</MenuItem>
          {
            (this.props.folder === 'inbox' || this.props.folder === 'notifications') && canMarkRead
              ? <MenuItem onClick={ this.handleMarkRead.bind(this, true) }>Mark as read</MenuItem>
              : null
          }
          {
            (this.props.folder === 'inbox' || this.props.folder === 'notifications') && (this.props.forBatch || this.props.message.read)
              ? <MenuItem onClick={ this.handleMarkRead.bind(this, false) }>Mark as unread</MenuItem>
              : null
          }
          {
            this.props.folder === 'inbox' && canMarkProcessed
              ? <MenuItem onClick={ this.handleMarkProcessed.bind(this) }>Mark as processed</MenuItem>
              : null
          }
          {
            this.props.folder === 'inbox' && !this.props.relatedObject
              ? <MenuItem onClick={ this.handleMarkJunk.bind(this, true) }>Mark as junk</MenuItem>
              : null
          }
          {
            this.props.folder === 'junk' && !this.props.relatedObject
              ? <MenuItem onClick={ this.handleMarkJunk.bind(this, false) }>Mark as not junk</MenuItem>
              : null
          }
          {
            this.props.folder === 'sent' && (this.props.forBatch || !this.props.message.answered)
              ? <MenuItem onClick={ this.handleMarkReplied.bind(this, true) }>Mark as replied</MenuItem>
              : null
          }
          {
            this.props.folder === 'sent' && (this.props.forBatch || this.props.message.answered)
              ? <MenuItem onClick={ this.handleMarkReplied.bind(this, false) }>Mark as not replied</MenuItem>
              : null
          }
          {
            this.props.folder === 'inbox' && this.props.forDisplay
              ? <MenuItem onClick={ this.handleReply.bind(this, this.props.message) }>Reply</MenuItem>
              : null
          }
          {
            this.props.forDisplay && !['draft', 'trash'].includes(this.props.folder)
              ? <MenuItem onClick={ this.props.onForward }>Forward</MenuItem>
              : null
          }
          {
            this.props.forDisplay && !this.props.relatedObject
              ? <MenuItem onClick={ this.handleClickOffer.bind(this, 'send_proposal') }>Send a proposal/offer</MenuItem>
              : null
          }
          {
            this.props.forDisplay && this.props.relatedObject && this.props.message.related_object_type === 'inquiry'
              ? <MenuItem onClick={ this.handleClickOffer.bind(this, 'make_offer') }>Make an offer</MenuItem>
              : null
          }
          {
            this.props.forDisplay && !this.props.relatedObject
              ? <MenuItem onClick={ this.props.onAttachBooking }>Attach to inquiry/reservation</MenuItem>
              : null
          }
        </DropdownButton>
        {
          !!this.state.selectedAction
            ? <Modal onClose={ this.handleCancelAction } onAccept={ this.handleConfirmAction } title={ this.state.selectedAction.title } loading={ this.props.loading }>
                { this.state.selectedAction.message }
              </Modal>
            : null
        }
        {
          !!this.state.sendOffer
            ? <Modal onClose={ this.handleCancelAction } title="Search availabilities">
                <SearchForm
                  { ...this.props.searchParams }
                  onChange={ this.props.onChangeSearchParams }
                  onSubmit={ this.handleSearch }
                />
              </Modal>
            : null
        }
      </div>
    );
  }
  handleCancelAction() {
    this.setState({ selectedAction: null, sendOffer: null });
  }
  handleConfirmAction() {
    let action;
    const actionType = this.state.selectedAction.type;
    const ids = this.props.forBatch
      ? Object.keys(this.props.selectedItems).filter(id => !!this.props.selectedItems[id] )
      : [this.props.message.id];
    switch(actionType) {
    case 'delete':
      action = this.props.api.message.postData({ url: '/delete', data: { ids } });
      break;
    case 'markRead':
      action = this.props.api.message.postData({ url: '/change-read-status', data: { read: true, ids } });
      break;
    case 'markUnread':
      action = this.props.api.message.postData({ url: '/change-read-status', data: { read: false, ids } });
      break;
    case 'markProcessed':
      action = this.props.api.message.postData({ url: '/change-pending-status', data: { pending: false, ids } });
      break;
    case 'markJunk':
      action = this.props.api.message.postData({ url: '/change-junk-status', data: { junk: true, ids } });
      break;
    case 'markUnjunk':
      action = this.props.api.message.postData({ url: '/change-junk-status', data: { junk: false, ids } });
      break;
    case 'markReplied':
      action = this.props.api.message.postData({ url: '/change-replied-status', data: { answered: true, ids } });
      break;
    case 'markNotReplied':
      action = this.props.api.message.postData({ url: '/change-replied-status', data: { answered: false, ids } });
      break;
    }
    return action
      .then(() => {
        this.setState({ selectedAction: null });
        if (this.props.postDataSuccessful) {
          this.props.api.message.setData({ postDataSuccessful: false });
          if (this.props.onActionSuccessful) this.props.onActionSuccessful(actionType);
        }
      });
  }

  handleDelete() {
    const message = !this.props.forBatch
      ? 'Are you sure you want to delete this message ?'
      : 'Are you sure you want to delete the selected messages ?';
    const selectedAction = { type: 'delete', title: 'Delete', message };
    this.setState({ selectedAction });
  }
  handleEdit(message) {
    this.props.api.routing.redirect(this.props.router, `${this.props.mountedUrl}/${message.id}/edit`);
  }
  handleReply(message) {
    this.props.api.routing.redirect(this.props.router, `${this.props.mountedUrl}/${message.id}/reply`);
  }
  handleMarkRead(bool) {
    const messageRead = !this.props.forBatch
      ? 'Are you sure you want to set this message as read ?'
      : 'Are you sure you want to set the selected messages as read ?';
    const messageNotRead = !this.props.forBatch
      ? 'Are you sure you want to set this message as not read ?'
      : 'Are you sure you want to set the selected messages as not read ?';
    const selectedAction = bool
      ? { type: 'markRead', title: 'Mark as read', message: messageRead }
      : { type: 'markUnread', title: 'Mark as not read', message: messageNotRead };
    this.setState({ selectedAction });
  }
  handleMarkProcessed() {
    const message = !this.props.forBatch
      ? 'Are you sure you want to mark this message as processed ?'
      : 'Are you sure you want to mark the selected messages as processed ?';
    const selectedAction = { type: 'markProcessed', title: 'Mark as processed', message };
    this.setState({ selectedAction });
  }
  handleMarkJunk(bool) {
    const messageJunk = !this.props.forBatch
      ? 'Are you sure you want to mark this message as junk ?'
      : 'Are you sure you want to mark the selected messages as junk ?';
    const messageNotJunk = !this.props.forBatch
      ? 'Are you sure you want to mark this message as not junk ?'
      : 'Are you sure you want to mark the selected messages as not junk ?';
    const selectedAction = bool
      ? { type: 'markJunk', title: 'Mark as junk', message: messageJunk }
      : { type: 'markUnjunk', title: 'Mark as not junk', message: messageNotJunk };
    this.setState({ selectedAction });
  }
  handleMarkReplied(bool) {
    const messageReplied = !this.props.forBatch
      ? 'Are you sure you want to mark this message as replied ?'
      : 'Are you sure you want to mark the selected messages as replied ?';
    const messageNotReplied = !this.props.forBatch
      ? 'Are you sure you want to mark this message as not replied ?'
      : 'Are you sure you want to mark the selected messages as not replied ?';
    const selectedAction = bool
      ? { type: 'markReplied', title: 'Mark as replied', message: messageReplied }
      : { type: 'markNotReplied', title: 'Mark as not replied', message: messageNotReplied };
    this.setState({ selectedAction });
  }

  handleClickOffer(action) {
    if (action === 'send_proposal') {
      this.setState({ sendOffer: action });
    } else { // make offer
      const queryParams = {
        action,
        reference: this.props.relatedObject.reference,
        message_id: this.props.message.id,
        arrival_date: this.props.relatedObject.arrival_date,
        departure_date: this.props.relatedObject.departure_date,
        nb_adults: this.props.relatedObject.nb_adults || 0,
        nb_young_adults: this.props.relatedObject.nb_young_adults || 0,
        nb_children: this.props.relatedObject.nb_children || 0,
        nb_young_children: this.props.relatedObject.nb_young_children || 0,
        ignore_conditions: this.props.relatedObject.ignore_conditions ? 1 : 0,
      };
      const queryString = Object.keys(queryParams).map(attr => `${attr}=${queryParams[attr]}`).join('&');
      this.props.api.routing.redirect(this.props.router, `/daily-rental/availabilities/search?${queryString}`);
    }
  }
  handleSearch() {
    const searchParams = this.props.searchParams || {};
    if (searchParams.arrival_date && searchParams.departure_date) {
      const queryParams = {
        message_id: this.props.message.id,
        action: this.state.sendOffer,
        arrival_date: searchParams.arrival_date,
        departure_date: searchParams.departure_date,
        nb_adults: searchParams.nb_adults || 0,
        nb_young_adults: searchParams.nb_young_adults || 0,
        nb_children: searchParams.nb_children || 0,
        nb_young_children: searchParams.nb_young_children || 0,
        ignore_conditions: searchParams.ignore_conditions ? 1 : 0,
      };
      if (this.props.message.related_object_reference) {
        queryParams.message_reference = this.props.message.related_object_reference;
      }
      const query = { ...this.props.location.query, ...queryParams };
      const pathname = '/management/daily-rental/availabilities/search';
      this.props.router.push({ ...this.props.location, pathname, query });
    }
  }
}

export default ItemActions;



// WEBPACK FOOTER //
// ./src/frontend/modules/email/message/components/ItemActions.jsx